import axios from 'axios';

export default axios.create({
   //baseURL: "https://refugiadonacozinha.com.br/"
   // baseURL:"http://localhost/RestoAfrica/src/views/"
    baseURL:"https://congolinaria.com.br/"
});